// modal code
$('.ps-trigger').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });

$('#ps-close').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });

  $('#mobile-ps-close').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });
  


// $('.ps-mute').on('click', function(e) {
// 	//var myVideo_0 = document.getElementById("ps_herovideo_0");
// 	//myVideo_0.muted = false;
// 		var iframe = document.getElementsByTagName('iframe')[0];
// 		if ($(this).hasClass('mute')) {
// 			$(this).removeClass('mute');
// 			iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
// 		} else {
// 			$(this).addClass('mute');
// 			iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
// 		}
// 	e.preventDefault();
//   });

var heroiframe = document.getElementsByTagName('iframe')[0];
if(heroiframe){
let player = new Vimeo.Player(heroiframe);
let width = screen.width;
if (width > 961) {
	player.play();
} else {
	$('.ps-play-pause').text("Resume");
	player.pause();
}
}

$('.ps-play-pause').on('click', function(e) {
		var iframe = document.getElementsByTagName('iframe')[0];
		let player = new Vimeo.Player(iframe);
		player.getPaused().then(function(paused) {
			if(paused){
				$('.ps-play-pause').text("Pause");
				$('.ps-play-pause').removeClass('ps-play-pause-2');
				player.play();
			 } else {
				$('.ps-play-pause').text("Play");
				$('.ps-play-pause').addClass('ps-play-pause-2');
				player.pause();
			 }
		  });
	e.preventDefault();
  });


		var video_frame = document.querySelectorAll(".ps-videos-component-iframe");
		var play_btn = document.querySelectorAll(".ps-videos-component");
		var nodelist = video_frame.length;
		for (i = 0; i < nodelist; i++) {
			el = video_frame[i];
			let player = new Vimeo.Player(el);
			 player.play();
			 let width = screen.width;
			 if (width > 961) {
			 player.pause();
			$(play_btn[i]).hover(function() {
				player.play();
			}, function() {
				player.pause();
			});
		 }
		}

		$('.ps-trigger').on('click', function() {
			
			let width = screen.width;
			 if (width > 960){
				var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
				player1.pause();
				player2.play();
				console.log('even' + width);
			 }else{
				var video1  = $('.ps_herovideo_cls');
			var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player3 = new Vimeo.Player(video3);
				player1.pause();
				player3.play();
				console.log('odd' + width);
			 }
			
			
		});

		$('.ps-close').on('click', function() {
			var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			// var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
			// var player3 = new Vimeo.Player(video3);

			player1.play();
			player2.pause();
			// player3.pause();
			
		});

		$('.mobile-ps-close').on('click', function() {
			var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
			var player3 = new Vimeo.Player(video3);

			player1.play();
			player2.pause();
			player3.pause();
			
		});


		///////// lets make own lightweight slider

		document.addEventListener('DOMContentLoaded', function() {
			// Get all sliders
			var sliders = document.querySelectorAll('.hero-area-banner-wrap .slides');
		
			sliders.forEach(function(slider) {
				var isDown = false;
				var startX;
				var scrollLeft;
		
				// Make each li focusable and add ARIA label
				var items = slider.querySelectorAll('li');
				items.forEach(function(item, index) {
					item.setAttribute('tabindex', '0');
					item.setAttribute('aria-label', 'Slide ' + (index + 1));
				});
		
				slider.addEventListener('mousedown', function(e) {
					isDown = true;
					slider.classList.add('active');
					startX = e.pageX - slider.offsetLeft;
					scrollLeft = slider.scrollLeft;
				});
		
				slider.addEventListener('mouseleave', function() {
					isDown = false;
					slider.classList.remove('active');
				});
		
				slider.addEventListener('mouseup', function() {
					isDown = false;
					slider.classList.remove('active');
				});
		
				slider.addEventListener('mousemove', function(e) {
					if(!isDown) return;
					e.preventDefault();
					var x = e.pageX - slider.offsetLeft;
					var walk = (x - startX) * 3; //scroll-fast
					slider.scrollLeft = scrollLeft - walk;
				});
		
				// Touch events 
				slider.addEventListener('touchstart', function(e) {
					isDown = true;
					slider.classList.add('active');
					startX = e.touches[0].pageX - slider.offsetLeft;
					scrollLeft = slider.scrollLeft;
				}, false);
		
				slider.addEventListener('touchend', function() {
					isDown = false;
					slider.classList.remove('active');
				}, false);
		
				slider.addEventListener('touchmove', function(e) {
					if(!isDown) return;
					e.preventDefault();
					var x = e.touches[0].pageX - slider.offsetLeft;
					var walk = (x - startX);
					slider.scrollLeft = scrollLeft - walk;
				}, false);
			});
		});
		
// Get the iframe element
const iframe = document.getElementById('intro_video');


// if(iframe){
// 	iframe.addEventListener('load', function() {
// 		document.getElementById('loader').style.display = 'none';
// 	  });
// }

// document.addEventListener("DOMContentLoaded", function() {
//     var iframe = document.getElementById('intro_video');
//     var thumbnailImg = document.getElementById('vimeo-thumbnail');

//     iframe.addEventListener('load', function() {
//         thumbnailImg.style.display = 'block'; // Hide thumbnail when video is loaded
//     });
// });

// const iframe = document.getElementById('intro_video');
// var thumbnailImg = document.getElementById('vimeo-thumbnail');
// if(iframe){
// 	thumbnailImg.style.display = 'block';
// 	document.querySelector(".hero-area-banner-image").style.padding = '0%';

// 	iframe.addEventListener('load', function() {
// 		document.querySelector(".hero-area-banner-image").style.padding = "57.25% 0 0 0";
// 		// document.getElementById('loader').style.display = 'none';
// 		thumbnailImg.style.display = 'none';
// 	  });
// }
